/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ cost: NonNullable<unknown>, balance: NonNullable<unknown> }} Creditcostwithbalance3Inputs */

const en_creditcostwithbalance3 = /** @type {(inputs: Creditcostwithbalance3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Costs ${i?.cost} credits · balance: ${i?.balance} credits`)
};

const de_creditcostwithbalance3 = /** @type {(inputs: Creditcostwithbalance3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kostet ${i?.cost} Credits · Guthaben: ${i?.balance} Credits`)
};

/**
* | output |
* | --- |
* | "Costs {cost} credits · balance: {balance} credits" |
*
* @param {Creditcostwithbalance3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const creditcostwithbalance3 = /** @type {((inputs: Creditcostwithbalance3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creditcostwithbalance3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_creditcostwithbalance3(inputs)
	return de_creditcostwithbalance3(inputs)
});
export { creditcostwithbalance3 as "creditCostWithBalance" }